







import { defineComponent } from '@vue/composition-api';
import DriftFacade from '~/components/DriftFacade.vue';

export default defineComponent({
  name: 'BaseLayout',
  components: {
    DriftFacade,
    // Announcement,
  },
  computed: {
    isCurrentRouteShopProductsFightcamp() {
      return this.$store.getters.currentRoute?.name === 'shop-products-fightcamp';
    },
    displayBanner() {
      const isNavTypeConfirmation = this.$store.getters.navType === 'confirmation';
      const isNavTypeGQ = this.$store.getters.navType === 'gq';

      return (
        !(isNavTypeConfirmation || isNavTypeGQ || this.isCurrentRouteShopProductsFightcamp)
      );
    },
    displayFacade() {
      return !this.isCurrentRouteShopProductsFightcamp;
    },
  },
  methods: {
    handleClick() {
      this.$router.push('/shop/products/fightcamp');
    },
  },
});
